<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Transaksi Gadai</h5>
            </template>
            <div class="detail-data-wrapper">
                <h6 class="form-title">TRANSAKSI GADAI BARU</h6>
                <b-table bordered hover show-empty :fields="fields" :busy="isBusy2" :items="transaksiBaru" responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada transaksi gadai baru.
                    </template>
                    <template v-slot:cell(namaAnggota)="row">
                        <p class="mb-0">{{row.item.namaAnggota}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.noAnggota}}</p>
                    </template>
                    <template v-slot:cell(barang)="row">
                        <p class="mb-0">{{row.item.jenisBarang}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.merk}} - {{row.item.tipe}}</p>
                    </template>
                    <template v-slot:cell(nilaiPinjamanEfektif)="row">
                        <div class="text-right no-wrap" v-if="row.item.nilaiPinjamanEfektif == null">{{$helper.addThousandSeparator(row.item.nilaiPinjamanEfektif)}} </div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nilaiPinjamanEfektif)}} </div>
                        <p class="mb-0 text-right smallText text-muted">{{ textDisburse(row.item.disburseType) }}</p>
                    </template>
                    <template v-slot:cell(action)="row">
                        <div class="no-wrap">
                            <b-link :to="`${$route.path}/${row.item.id}`">
                                <b-button size="sm" class="mr-2" variant="pgiBtn" v-b-tooltip.hover title="Detail" name="transaksiViewBtn">
                                    <i class="fa fa-info"></i>
                                </b-button>
                            </b-link>
                        </div>
                    </template>
                </b-table>
            </div>
            <div class="detail-data-wrapper">
                <h6 class="form-title">HISTORY TRANSAKSI GADAI HARI INI</h6>
                <div class="search-wrapper d-flex align-items-center justify-content-between">
                    <b-form-group
                        label="Filter"
                        label-for="filterInput"
                        class="form-inline form-group-wrapper mb-3"
                    >
                        <div class="d-flex search-input-wrapper">
                            <b-form-input class="ml-2 mr-2"
                                v-model="input.filterNoFaktur" name="filterNoFaktur"
                                id="filterInput"
                                type="search"
                                placeholder="Masukkan no. faktur"
                            ></b-form-input>
                            <b-form-input class="mr-2"
                                v-model="input.filterNoAnggota" name="filterNoAnggota"
                                type="search"
                                placeholder="Masukkan no. anggota"
                            ></b-form-input>
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter2"> 
                                <i class="fa fa-search"></i>
                            </b-button>
                            <b-button variant="pgiBtn" name="reseFilterBtn" :disabled="isBusy" @click="onReset2">Reset</b-button>
                        </div>
                    </b-form-group>
                </div>
                <b-table bordered hover show-empty 
                    :busy="isBusy" 
                    :items="transaksiHistory"
                    :no-local-sorting="false" 
                    :fields="fields2"
                    @sort-changed="sortingChanged2" 
                    responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada history transaksi gadai.
                    </template>
                    <template v-slot:cell(namaAnggota)="row">
                        <p class="mb-0">{{row.item.namaAnggota}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.noAnggota}}</p>
                    </template>
                    <template v-slot:cell(barang)="row">
                        <p class="mb-0">{{row.item.jenisBarang}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.merk}} - {{row.item.tipe}}</p>
                    </template>
                    <template v-slot:cell(nilaiPinjamanEfektif)="row">
                        <div class="text-right no-wrap" v-if="row.item.nilaiPinjamanEfektif == null">{{$helper.addThousandSeparator(row.item.nilaiPinjamanEfektif)}} </div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nilaiPinjamanEfektif)}} </div>
                        <p class="mb-0 text-right smallText text-muted">{{ textDisburse(row.item.disburseType) }}</p>
                    </template>
                    <template v-slot:cell(status.name)="row">
                        <b-badge variant="dark" v-if="row.item.status.name == 'Baru'">BARU</b-badge>
                        <b-badge variant="primary" v-else-if="row.item.status.name == 'Berjalan'">BERJALAN</b-badge>
                        <b-badge variant="danger" v-else-if="row.item.status.name == 'Void'">VOID</b-badge>
                        <b-badge variant="success" v-else-if="row.item.status.name == 'Lunas'">LUNAS</b-badge>
                        <b-badge v-else>{{ row.item.status.name }}</b-badge>     
                    </template>
                    <template v-slot:cell(action)="row">
                        <div class="no-wrap">
                            <b-link :to="`${$route.path}/${row.item.id}`">
                                <b-button size="sm" class="mr-2" variant="pgiBtn" v-b-tooltip.hover title="Detail" name="transaksiViewBtn">
                                    <i class="fa fa-info"></i>
                                </b-button>
                            </b-link>
                        </div>
                    </template>
                </b-table>
                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="input.showHistory" :options="options" @change="onLimitChange2">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ totalViewText2 }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0"
                    v-model="currentPageHistory"
                    :total-rows="rowsHistory"
                    :per-page="perPageHistory"
                    @input="onPageChange2"
                    aria-controls="my-table"
                    ></b-pagination>
                </div>
            </div>

            <b-modal id="modal-upload-bukti" title="Upload Bukti" no-close-on-backdrop>
            No. Faktur : {{ activeFaktur }}

            <div v-for="item of required" class="my-2" v-if="required.length != 0">
                {{ item.name }} <span v-if="item.isRequired" class="text-danger">*</span>
                <div class="d-flex">
                    <b-button class="mr-2" v-if="item.path != null" variant="cancelBtn" @click="viewFoto(item)">
                        Lihat Foto
                    </b-button>
                    <div class="browse-foto">
                        <b-form-file v-model="item.file" name="fotoBarangPendukung" :state="Boolean(item.file)"
                            drop-placeholder="Drop file here..." accept=".jpg, .png, .jpeg" @input="browseFile(item.type,item.file, (item.path != null) &&true ,item.id)">
                        </b-form-file>
                        <b-button variant="cancelBtn">
                            <i class="fa fa-upload"></i>
                           {{ (item.path != null) ?'Update Bukti' :'Upload'}}
                        </b-button>
                    </div>
                </div>
            </div>

            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="pgiBtn" name="closePreviewBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-loading" centered size="sm" hide-footer hide-header no-close-on-esc no-close-on-backdrop>
            <h4 class="text-center text-lg">LOADING ...</h4>
        </b-modal>
        
        <b-modal id="modal-preview-foto" size="xl" :title="activeFotoPreview.name">
            <div>
                No. Faktur : {{ activeFaktur }}
            </div>
            <div class="my-2">
                Oleh : {{ activeFotoPreview.createdBy }} , {{ $helper.changeDateFormat(activeFotoPreview.createdAt) }} {{
                    $helper.changeDateFormatGetHour(activeFotoPreview.createdAt) }}
           </div>
            <div class="modal-foto-wrapper">
                <img :src="$baseFilePath + activeFotoPreview.path" alt="Foto">
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                    Close
                </b-button>
            </template>
        </b-modal>
        </b-card>
    </div>
</template>

<script>
import CONSTANTS from '@/constants'

export default {
    name: 'transaksi-gadai',
    data(){
        return{
            id: null,
            initStatus: 0,
            isSubmitting: false,
            isBusy: true,
            isBusy2: true,

            activeFaktur:'',
            activeFotoPreview: '',

            sbgAwalGadai:{},
            sbgPelunasan:{},
            kwitansiPelunasan:{},
            notaHilang:{},

            required:[],

            input:{
                show: 10,
                showHistory: 10,
                sortDesc: null,
                sortBy: null,
                filter: null,
                filterNoFaktur: null,
                filterNoAnggota: null,
            },
            fields: [
                { key: "noFaktur", label: "No. Faktur"},
                { key: "namaAnggota", label: "Anggota"},
                { key: "barang", label: "Barang"},
                { key: "nilaiPinjamanEfektif", label: "Nilai Pinjaman"},
                { key: "action", label: "Aksi" },
            ],
            fields2: [
                { key: "noFaktur", label: "No. Faktur"},
                { key: "namaAnggota", label: "Anggota"},
                { key: "barang", label: "Barang"},
                { key: "nilaiPinjamanEfektif", label: "Nilai Pinjaman"},
                { key: "status.name", label: "Status" },
                { key: "cetakSBG", label: "# Print" },
                { key: "action", label: "Aksi" }
            ],
            transaksiBaruAll: [],
            transaksiBaru: [],
            transaksiHistory: [],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            currentPageHistory: 1,
            perPageHistory: 10,
            rowsHistory: null,
            totalViewTextHistory: "",
            pageHistory: '',
            sizeHistory: '',
            srcCabangId: null,
            loading: false,
            query: ""
        }
    },
    computed: {
        NON_TUNAI() {
            return CONSTANTS.GADAI.METODE_PENCAIRAN.NON_TUNAI
        },
    },
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.srcCabangId = this.$helper.getCabangId()

            let getTransaksiBaru = this.$axios.get("gadai/daftar-gadai-baru/?cabangId="+this.srcCabangId).then(response => {
                this.transaksiBaruAll = response.data
                this.transaksiBaru = response.data
                this.updateTotalItem()
            })

            this.pageHistory = 0
            this.sizeHistory = this.input.showHistory
            this.query = this.$helper.makeQuery(this.pageHistory, this.sizeHistory)

            let getTransaksiHistory = this.$axios.get("gadai/daftar-gadai/"+this.query+"&cabangId="+this.srcCabangId+"&excludeGadaiBaru=true").then(response => {
                this.transaksiHistory = response.data.data
                this.updateTotalItem2(response.data.total)
            })

            Promise.all([getTransaksiBaru, getTransaksiHistory]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
                this.toggleBusy2()

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //-----------------  Fungsi Ambil Data Transaksi Baru ----------------- 
        
        getTransaksiBaru(){
            this.transaksiBaru = this.transaksiBaruAll
            this.toggleBusy2()
            this.updateTotalItem()
        },


        //----------------- Fungsi Ambil Data Transaksi History -----------------

        getTransaksiHistory(){
            this.toggleBusy()
            this.transaksiHistory = []

            if (this.input.filterNoFaktur != null) this.query = this.query + "&filterNoFaktur=" + this.input.filterNoFaktur
            if (this.input.filterNoAnggota != null) this.query = this.query + "&filterNoAnggota=" + this.input.filterNoAnggota
            if (this.input.sortBy != null) this.query = this.query + "&sortBy=" + this.input.sortBy
            if (this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc
            
            this.$axios.get("gadai/daftar-gadai/"+this.query+"&cabangId="+this.srcCabangId+"&excludeGadaiBaru=true").then(response => {
                this.transaksiHistory = response.data.data
                this.toggleBusy()
                this.updateTotalItem2(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        fetchSBG(faktur){
            this.$axios.get(`gadai-evidence/?noFaktur=${faktur}`)
            .then(response => {

                for(let item of response.data){
                    item.file = []
                }
                this.required = response.data            
            }).catch(error => {
                // Tindakan jika terjadi kesalahan
                console.log(error);
                this.initStatus = -1;
            }); 
        },

        uploadBukti(id,item){
            this.activeFaktur = item
            this.fetchSBG(item)
            this.$bvModal.show('modal-upload-bukti')
        },

        browseFile(type, file , upload = false,id) {
            if (file == null) {
                return
            }

            this.$bvModal.show("modal-loading")
            let formData = new FormData();

            if(upload){
                formData.append('id', id);
                formData.append('file', file);
                
                this.$axios.post(`gadai-evidence/update/`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.$helper.toastSucc(this, "foto berhasil diUbah!")
                    this.fetchSBG(this.activeFaktur)
                    this.$bvModal.hide("modal-loading")
                }).catch(error => {
                    // Tindakan jika terjadi kesalahan
                    console.log(error);
                    this.$helper.toastErr(this,error.response.data.reason)
                    this.$bvModal.hide("modal-loading")
                });
            } else {
                formData.append('noFaktur', this.activeFaktur);
                formData.append('type', type);
                formData.append('file', file);
                
                this.$axios.post(`gadai-evidence/insert`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.$helper.toastSucc(this, "foto berhasil diupload!")
                    this.fetchSBG(this.activeFaktur)
                    this.$bvModal.hide("modal-loading")
                }).catch(error => {
                    // Tindakan jika terjadi kesalahan
                    console.log(error);
                    this.$helper.toastErr(this,error.response.data.reason)
                    this.$bvModal.hide("modal-loading")
                });
            }
        },

        viewFoto(item){
            this.activeFotoPreview = item
            this.$bvModal.show("modal-preview-foto")
        },


        //----------------- Fungsi Pagination, Sorting, dan loading untuk Transaksi Baru -----------------

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        onFilter(letters){
            let filteredArray = []
            for (var x of this.transaksiBaruAll) {
                if (x.name.toLowerCase().includes(letters.toLowerCase())) {
                    filteredArray.push(x)
                }
            }

            this.transaksiBaru = filteredArray
            this.onFiltered(this.transaksiBaru)
        },

        onFiltered(filteredItems){
            this.rows = filteredItems.length
            this.currentPage = 1
            let prevLimit = null
            let limit = null
            this.perPage = this.input.show
            prevLimit = (this.currentPage-1) * this.rows + 1
            limit = (this.currentPage-1) * this.rows + this.rows
            if (limit > this.input.show) limit = this.input.show
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onReset(){
            this.input.filter = ""
            this.toggleBusy2()
            this.getTransaksiBaru()
        },


        //----------------- Fungsi Pagination, Sorting, dan loading untuk Transaksi History -----------------

        onLimitChange2(){
            this.sizeHistory = this.input.showHistory
            this.perPageHistory = this.input.showHistory
            this.currentPage = 1
            this.pageHistory = 0
            this.query = this.$helper.makeQuery(0, this.sizeHistory)
            this.getTransaksiHistory()
        },

        onPageChange2(){
            if (this.loading == false) {
                this.pageHistory = this.currentPageHistory - 1
                this.query = this.$helper.makeQuery(this.pageHistory, this.sizeHistory)
                this.getTransaksiHistory()
            }
        },

        sortingChanged2(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter2()
            }
        },

        onReset2(){
            this.input.filterNoFaktur = null
            this.input.filterNoAnggota = null
            this.currentPage = 1
            this.pageHistory = 0
            this.query = this.$helper.makeQuery(0, this.sizeHistory)
            this.loading = true
            this.getTransaksiHistory()
        },

        onFilter2(){
            this.pageHistory = 0
            this.currentPageHistory = 1
            this.query = this.$helper.makeQuery(0, this.sizeHistory)
            this.loading = true
            this.getTransaksiHistory()
        },

        //----------------- Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },
        
        toggleBusy2() {
            if(this.isBusy2 == true) this.isBusy2 = false
            else this.isBusy2 = true
        },

        updateTotalItem(){
            this.rows = this.transaksiBaruAll.length
            if (this.perPage > this.rows) this.perPage = this.rows
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },

        updateTotalItem2(total){
            let limit = null
            let prevLimit = null
            this.perPageHistory = this.sizeHistory

            this.rowsHistory = total
            prevLimit = this.pageHistory * this.sizeHistory + 1
            limit = this.pageHistory * this.sizeHistory + this.sizeHistory
            if (limit > this.rowsHistory) limit = this.rowsHistory
            this.totalViewText2 = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rowsHistory + " entri"
        },

        textDisburse(disburseType) {
            if (disburseType == this.NON_TUNAI) {
                return 'Non Tunai (Transfer)'
            } else {
                return 'Tunai'
            }
        }
    },
    created(){
        this.init()
    }
}
</script>
<style scoped>
.browse-foto{
    position: relative;
}

.browse-foto .custom-file{
    opacity: 0;
    z-index: 1;
}

.browse-foto .custom-file .custom-file-input{
    z-index: 0;
}

.browse-foto .custom-file .custom-file-label{
    cursor: pointer;
}

.browse-foto button{
    position: absolute;
    top: 0;
    left: 0;
}
.browse-foto{
        margin-right: 10px;
    }
</style>